import { Fragment, memo } from "react";
import { Input as ReactStrapInput, Label } from "reactstrap";

interface Option {
    label: string;
    value: string | boolean;
}

interface Props {
    form: any;
    name: string;
    label?: string,
    afterLabel?: string;
    options?: Option[];
}

const InputRadio = ({ form, label = '', name, afterLabel = '', options }: Props) => {
    const finalOptions: Option[] = 
    options && options.length > 0 ? options :
    [
        {
            label: 'Yes',
            value: true,
        },
        {
            label: 'No',
            value: false,
        }
    ];

    const inputs = finalOptions.map(({ label, value}) => {
        const id = `radio-input-${name}-${label}`;
        return (
            <div key={id} className="d-flex text-nowrap">
                <ReactStrapInput
                    id={id}
                    name={name}
                    type="radio"
                    onChange={() => {
                        form.setFieldValue(name, value);
                    }}
                    onClick={() => {
                        form.setFieldValue(name, value);
                    }}
                    className="me-2"
                    checked={form?.values[name] === value}
                    value={label}
                />
                <label htmlFor={id} className="me-5">{label}</label>
            </div>
        );
    });

    return (
        <>
            <Label className="form-label">{label}{afterLabel && (<span className="fw-normal">{afterLabel}</span>)}</Label><br/>
            <div className="d-flex flex-wrap">{inputs}</div>
        </>
    );
};

export default memo(InputRadio);
